/**
 * RoleGuard — Allow only specified roles; redirect others to /.
 */

import { Navigate } from 'react-router-dom';
import { useUserRole, type UserRole } from '../../hooks/useUserRole';
import { Spinner } from '../ui';

interface RoleGuardProps {
  allow: UserRole[];
  children: React.ReactNode;
}

export function RoleGuard({ allow, children }: RoleGuardProps) {
  const { role, isLoading } = useUserRole();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!role || !allow.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
